import styled from 'styled-components';
import Colors from 'assets/Colors';
import Constants from 'helpers/constants';

const HeaderContainer = styled.div`
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: space-between;
`;

const LocationTitle = styled.div`
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
`;

const LogoContainer = styled.img`
  width: 90px;
  position: absolute;
  left: calc(50vw - 45px);
`;

const StoreContainer = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
  position: absolute;
  left: 207px;
`;

const LeftElements = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    display: none;
  }
`;

const LeftElementsSmallScreen = styled.div`
  display: none;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    display: flex;
    align-items: center;
  }
`;

const RightElements = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    display: none;
  }
`;

const VerticalSeparator = styled.div`
  border-left: 1px solid ${Colors.line_separator};
  height: 32px;
  margin-right: 11px;
`;

export default {
  HeaderContainer,
  LocationTitle,
  LogoContainer,
  StoreContainer,
  LeftElements,
  LeftElementsSmallScreen,
  RightElements,
  VerticalSeparator,
};
